export const SecurityPrinciple = ({ num, title, desc }) => (
  <div
    data-testid={`security-principle-${num}`}
    className="group border-t border-onix-line py-8 grid md:grid-cols-12 gap-4 md:gap-8 transition-colors duration-300 hover:bg-onix-black2"
  >
    <span className="tech-label md:col-span-1 pt-1">{num}</span>
    <h3 className="md:col-span-4 font-sans font-bold text-base text-onix-white">{title}</h3>
    <p className="md:col-span-7 text-sm leading-relaxed text-onix-silver">{desc}</p>
  </div>
);
